import { createI18n  } from "vue-i18n";
import axios from "axios";
import {Constants} from "@/cfg/constants";
import store from "@/store";

export const i18n = createI18n ({
    locale: store.state.locale.locale,
    fallbackLocale: "en",
    silentTranslationWarn: true
})
function setI18nLanguage(lang) {
    if (i18n.mode === 'legacy') {
        i18n.global.locale = lang
    } else {
        i18n.global.locale.value = lang
    }
    document.querySelector("html").setAttribute("lang", lang);
    return lang;
}

export function regionKey(key) {
    return Constants.REGION === Constants.DEFAULT_REGION ? key : `${Constants.REGION}_${key}`;
}

// Region-aware $t: uses the "<region>_<key>" override when the dictionary has it,
// otherwise falls back to the base key.
export const regionI18n = {
    install(app) {
        app.config.globalProperties.$tr = function (key, ...args) {
            const scopedKey = regionKey(key);
            return this.$te(scopedKey) ? this.$t(scopedKey, ...args) : this.$t(key, ...args);
        }
    }
}

export function loadLanguageAsync(lang) {
    return axios.get(Constants.API_URL_V2 + '/admin/translations',
        { params: { lang: lang }
        }).then((response) => {

        let msgs = response.data;
        i18n.global.setLocaleMessage(lang, msgs);
        //i18n.setLocaleMessage(lang, msgs);
        setI18nLanguage(lang);
    })
}
